import getTimezoneOfAddress from 'utils/addresses/methods/getTimezoneOfAddress';
import getTimezoneFromAddressFromTimeKey from 'utils/addresses/methods/getTimezoneFromAddressFromTimeKey';
import getAddressFromStopKey from 'utils/addresses/methods/getAddressFromStopKey';
import getAddressesFromPOIServiceResponse from 'utils/addresses/methods/getAddressesFromPOIServiceResponse';
import getCoordinatesFromPOIServiceResponse from 'utils/addresses/methods/getCoordinatesFromPOIServiceResponse';
import getPOIServiceParamsFromAddressParserResponse from 'utils/addresses/methods/getPOIServiceParamsFromAddressParserResponse';

export default {
  getTimezoneOfAddress,
  getTimezoneFromAddressFromTimeKey,
  getAddressFromStopKey,
  getAddressesFromPOIServiceResponse,
  getCoordinatesFromPOIServiceResponse,
  getPOIServiceParamsFromAddressParserResponse,
};
